var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.name,class:_vm.itemClass(item),on:{"click":function($event){_vm.$emit('child-click', item)}}},[_c('td',[_vm._v("\n            "+_vm._s(_vm.localizeName(item.name))+"\n        ")]),_vm._v(" "),_vm._l((item.data),function(entry){return _c('td',[_vm._v("\n            "+_vm._s(entry.value)+"\n        ")])})],2)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d1dad9c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/geotable/GeoTableBody.vue
// module id = 796
// module chunks = 1